import { notificationApi } from '@bingads-webui-campaign/notification-center';

export function createErrorHandlePipe(...handleFunctions) {
  return (error) => {
    for (let index = 0; index < handleFunctions.length; index += 1) {
      const handleFunction = handleFunctions[index];
      const isErrorHandled = handleFunction(error);
      if (isErrorHandled) {
        return;
      }
    }
  };
}

export class ErrorHandlerFactory {
  static createTryNotifyAdsApiError(i18n, errorCodeToErrorMessageMapping) {
    return function tryNotifyAdsApiError(errorResponseBody) {
      const isAdsApiError = errorResponseBody['@odata.context'] && errorResponseBody['@odata.context'].includes('Model.AdsApiError');
      let allErrorsHandled = false;
      if (isAdsApiError) {
        const errorDescriptors = errorResponseBody.value;
        errorDescriptors.forEach((errorDescriptor) => {
          const errorCode = errorDescriptor.Code;
          const mappedErrorText = errorCodeToErrorMessageMapping[errorCode] ? i18n.getString(errorCodeToErrorMessageMapping[errorCode]) : undefined;
          let errorText = errorCode;
          if (mappedErrorText) {
            errorText = mappedErrorText;
          } else if (errorDescriptor.Message) {
            errorText = errorDescriptor.Message;
          }

          notificationApi.showWarning(errorText);
        });
        allErrorsHandled = true;
      }
      return allErrorsHandled;
    };
  }

  static createNotifyGeneralError(i18n) {
    return function notifyGeneralError() {
      notificationApi.showWarning(i18n.getString(_TL_('We\'ve encountered an error. Please try again or contact support.')));
    };
  }
}

/**
 * encapsulate out-of-box error handle pipe
 */
export class ErrorHandlePipeFactory {
  static createNotifyErrorHandlerPipe(i18n, errorCodeToErrorMessageMapping) {
    return createErrorHandlePipe(
      ErrorHandlerFactory.createTryNotifyAdsApiError(i18n, errorCodeToErrorMessageMapping),
      ErrorHandlerFactory.createNotifyGeneralError(i18n)
    );
  }
}
